import { render } from "./LogsProjeto.vue?vue&type=template&id=fbd39ff2&scoped=true"
import script from "./LogsProjeto.vue?vue&type=script&lang=js"
export * from "./LogsProjeto.vue?vue&type=script&lang=js"

import "./LogsProjeto.vue?vue&type=style&index=0&id=fbd39ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd39ff2"]])

export default __exports__